import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

//
import { Card, Col, Row } from "react-bootstrap";
import ReactApexChart from "react-apexcharts";

//
import BoxLoading from "./BoxLoading";

function PieChart({
  chartOprions,
  title,
  loading = false,
  infoText,
  percent = false,
  total = false,
}) {
  const [key, setKey] = useState(0);

  const [option, setOption] = useState({
    series: [],
    labels: [],
    chart: {
      type: "donut",
      sparkline: {
        enabled: true,
      },
    },
    plotOptions: {
      pie: {
        startAngle: -100,
        endAngle: 100,
        donut: {
          size: "85%",
          labels: {
            show: true,
            name: {
              offsetY: 25,
              show: true,
              fontSize: "22px",
              fontWeight: 600,
              color: "#373d3f",
            },
            value: {
              offsetY: -20,
              show: true,
              fontSize: "22px",
              fontWeight: 600,
              color: "#373d3f",
            },
            total: {
              show: true,
              showAlways: true,
              label: "Total",
              fontSize: "22px",
              fontWeight: 600,
              color: "#373d3f",
              formatter: function (w) {
                return w.globals.seriesTotals.reduce((a, b) => {
                  return a + b;
                }, 0);
              },
            },
          },
        },
      },
    },
    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "center",
      width: "100%",
      floating: true,
      formatter(val, opts) {
        const name = opts.w.globals.labels[opts.seriesIndex];
        return [convertText(name)];
      },
      labels: {
        colors: ["#373d3f"],
      },
      markers: {
        width: 50,
        height: 5,
        fillColors: ["#FFD231", "#97D667", "#2FDB9D"],
      },
      onItemClick: {
        toggleDataSeries: false,
      },
      onItemHover: {
        highlightDataSeries: false,
      },
    },
    dataLabels: {
      enabled: false,
      style: {
        fontSize: "10px",
        colors: ["#373d3f"],
      },

      dropShadow: {
        enabled: false,
      },
      formatter(val, opts) {
        const name = opts.w.globals.labels[opts.seriesIndex];
        return [convertText(name)];
      },
    },
    tooltip: {
      enabled: false,
    },
    fill: {
      type: "gradient",
      colors: [],
    },
  });

  /**
   * Convert Title To Color
   */
  const convertTitleToColor = (key) => {
    if (key === "buy" || key === "won" || key === "profit") return "success";
    if (key === "trend_changed" || key === "potential_profit") return "muted";
    return "danger";
  };

  /**
   * Reduce For Show Total
   */
  const convertTotal = (values) => {
    let total = 0;
    for (const val of Object.values(values)) {
      total += +val;
    }

    return total;
  };

  /**
   * Set Charg Data
   */
  const setChartData = () => {
    let series = [];
    let labels = [];
    let colors = [];
    for (const [key, value] of Object.entries(chartOprions)) {
      labels.push(key);
      series.push(+value);
      if (key === "buy" || key === "won" || key === "profit") {
        colors.push("#2FDB9D");
      } else if (key === "trend_changed" || key === "potential_profit") {
        colors.push("#c0cbdd");
      } else {
        colors.push("#F64A4A");
      }
    }

    let chart = { ...option };
    chart.fill.colors = colors;
    chart.series = series;
    chart.labels = labels;
    chart.legend.markers.fillColors = colors;
    chart.plotOptions.pie.donut.labels.show = total;

    setOption(chart);
  };

  useEffect(() => {
    setChartData();
  }, [chartOprions]);

  const convertText = (text) => {
    let value = text.charAt(0).toUpperCase() + text.slice(1);
    return value.replace("_", " ");
  };

  return (
    <Card className="chart-card">
      <Row className="h-100">
        <Col xs={12} sm={8}>
          <Card id="pie-chart" className="h-100">
            <Card.Body>
              <p className="text-center text-black fw-bolder">{title}</p>

              <ReactApexChart
                key={key}
                options={option}
                series={option.series}
                type="donut"
                height={250}
              />

              <span></span>
            </Card.Body>

            {loading && <BoxLoading />}
          </Card>
        </Col>
        <Col className="d-block d-sm-none">
          <div className="space"></div>
        </Col>

        <Col xs={12} sm={4} className="infos">
          <div className="holder">
            <div className="item">
              <h6>{infoText}</h6>
              <h6>Count</h6>
            </div>

            {Object.entries(chartOprions).map(([key, value], i) => (
              <div className={`item ${convertTitleToColor(key)}`} key={i}>
                <h6 className="text-muted"> {convertText(key)}</h6>
                <div>
                  <p className="amount">
                    {value} {percent ? "%" : ""}
                  </p>
                </div>
              </div>
            ))}
            {total && (
              <div className="item dark">
                <h6>Total</h6>
                <div>
                  <p className="amount">
                    {convertTotal(chartOprions)} {percent ? "%" : ""}
                  </p>
                </div>
              </div>
            )}
          </div>
        </Col>
      </Row>
    </Card>
  );
}

PieChart.propTypes = {
  chartOprions: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  title: PropTypes.string.isRequired,
  infoText: PropTypes.string.isRequired,
  percent: PropTypes.bool,
  total: PropTypes.bool,
};

export default PieChart;
